import { useSubscriptionStatus } from "@hooks/use-current-user";
import SubscriptionPauseAskNew from "./SubscriptionPauseAskNew";
import SubscriptionPauseAlreadyAsked from "./SubscriptionPauseAlreadyAsked";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";

function SubscriptionPause() {
  const subscriptionStatus = useSubscriptionStatus();

  switch (subscriptionStatus) {
    case subscriptionStatuses.subscribed:
      return <SubscriptionPauseAskNew />;
    case subscriptionStatuses.subscribedWaitingForPause:
    case subscriptionStatuses.subscribedWaitingForPauseBlockedByCloset:
    case subscriptionStatuses.pastDueWaitingForPause:
    case subscriptionStatuses.paused:
      return <SubscriptionPauseAlreadyAsked />;
    default:
      return null;
  }
}

export default SubscriptionPause;
